import { Dashboard } from '@practium/features/dashboard';
import { useGetDashboardInfos } from '@practium/features/api';
import { getAdminDashboardConfig } from '../constants/getAdminDashboard.config';

export const DashboardPage = () => {
	const { data } = useGetDashboardInfos();
	const adminDashboard = data?.dashboardType === 'admin' ? data : undefined;
	const config = getAdminDashboardConfig(adminDashboard);

	return <Dashboard config={config} />;
};
